import React from 'react';
import { urlWithProtocol } from 'javascripts/url_helpers';
import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import renderIf from 'render-if';
import { sanitizeUrl } from 'javascripts/sanitizer';

const LinkIcon = () => {
  return <i slot='icon' className='fa-regular fa-link tw-text-secondary' />;
};

const LinkContents: React.FC<CardContentsComponent<'link'>> = ({
  link,
  contents,
}) => {
  const { externalUrl, linkIcon, linkIconOnly } = contents;

  return (
    <>
      {renderIf(linkIcon && !linkIconOnly)(() => (
        <>
          <LinkIcon />
          &nbsp;
        </>
      ))}
      <a
        href={sanitizeUrl(urlWithProtocol(externalUrl))}
        target='_blank'
        rel='noopener noreferrer nofollow'
      >
        {renderIf(linkIconOnly)(() => (
          <LinkIcon />
        ))}
        {renderIf(!linkIconOnly)(() => (
          <>{link}</>
        ))}
      </a>
    </>
  );
};

export default LinkContents;
